import React from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Box,
} from "@mui/material";

import Footer from "../componets/Footer";
import Header from "../componets/Header";
import NewsHeader from "../componets/NewsHeader";

// Example imports for images (replace with your actual paths or URLs)
import c1 from "../../../../assets/c1.png";
import c2 from "../../../../assets/c2.jpg";
import c3 from "../../../../assets/c3.png";
import c4 from "../../../../assets/c4.jpg";
import c5 from "../../../../assets/c5.png";

const LearningEnvironment = () => {
  const cardData = [
    {
      title: "LARGE CLASSROOMS",
      description: "Large classrooms designed for children.",
      image: c1,
      bgColor: "#2e62ac",
    },
    {
      title: "TECHNOLOGY",
      description:
        "Many classrooms are equipped with technology such as projectors, interactive whiteboards and Ipads.",
      image: c2,
      bgColor: "#f7d74b",
    },
    {
      title: "FREE ACCESS",
      description: "Promoting free access to materials and movement.",
      image: c3,
      bgColor: "#f43d2f",
    },
    {
      title: "SPECIAL DESIGN",
      description: "Specially designed child friendly furniture.",
      image: c4,
      bgColor: "#88c65e",
    },
    {
      title: "INTERACTIVE OUTDOORS",
      description: "Interactive outdoor learning areas.",
      image: c5,
      bgColor: "#2e62ac",
    },
    {
      title: "IMMERSIVE SPA",
      description: "Necessary sensory stimulus for creating happy brains.",
      image: c1,
      bgColor: "#f7d74b",
    },
  ];

  return (
    <>
      <NewsHeader />
      <Header />
      <Box
        sx={{
          width: "80%",
          mx: "auto",
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
          mt: 10,
        }}
      >
        <Typography
          sx={{
            fontSize: {xs:22,md:40},
            fontWeight: "bold",
            fontFamily: '-moz-initial',
            color: "#005ca8",
            mt: 2,
            mb: 2,
          }}
        >
          The ideal environment to nurture your Child
        </Typography>
        <Typography>
          At Podar Prep we consider the environment to be the Third Teacher (the
          first and second being the parent and teacher). Our unique early years
          environment incorporates vibrant design consideration for optimal
          learning, incorporating state-of-the art facilities and equipment to
          promote a holistic, creative and technologically-enriched early
          childhood learning program. The environment of the classrooms,
          corridors, and washrooms speaks of the children and the rich
          educational experiences that occur within it. The prime goal of our
          learning environment is to make children’s presence and voices visibly
          felt, heard and reflected.
        </Typography>
        <Typography
          sx={{
            fontSize: {xs:22,md:40},
            fontWeight: "bold",
            fontFamily: '-moz-initial',
            color: "#005ca8",
            mt: 4,
            mb: 2,
          }}
        >
          The Key learning spaces at Podar Prep includes:
        </Typography>
      </Box>

      <Grid
        container
        spacing={4}
        sx={{ width: "80%", mx: "auto", mt: 2, mb: 6 }}
      >
        {cardData.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                backgroundColor: item.bgColor,
                color: "#fff",
                borderRadius: 3,
                boxShadow: 3,
                transition: "transform 0.3s",
                "&:hover": {
                  transform: "scale(1.03)",
                },
                height: 400,
              }}
            >
              <CardMedia
                component="img"
                image={item.image}
                alt={item.title}
                height="200"
                sx={{
                  width: "90%",
                  mx: "auto",
                  borderRadius: 3,
                  border: "2px solid white",
                  mt: 2,
                }}
              />
              <CardContent>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    color: "#fff",
                    fontSize: 20,
                    fontFamily: '-moz-initial',
                    textAlign: "center",
                  }}
                >
                  {item.title}
                </Typography>
                <Typography sx={{ color: "#fff", textAlign: "center" }}>
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Footer />
    </>
  );
};

export default LearningEnvironment;

